module.exports = __webpack_public_path__ + "static/assets/48620c198b7ec2d6daf564badd34fa8d.jpg";